// CSS Grid template for new conditional formatting layout
// Columns: drag-button | label | type-picker | field | condition | value | delete-button
export const GRID_TEMPLATE_COLUMNS =
  '24px 130px minmax(150px, 1fr) minmax(150px, 1fr) minmax(120px, 1fr) minmax(200px, 2fr) 40px';
